<template lang="pug">
#ChallengeTerryberryAwardPoints.level.has-background-white.has-border-radius-large.p-3
  .level-left
    .level-item
      img(
        alt="Terry Berry Award Points Icon"
        src="https://walkertracker.s3.amazonaws.com/stride/icons/terryberry_award_points.svg"
      )
    .level-item
      span {{ dynamicAwardPointsText }}
    .level-item(v-if="challenge.isWellness")
      a.has-text-underlined(
        href="#"
        @click.prevent="clickLearnMore"
      ) Learn More

  // LEARN MORE MODAL
  //- BModal.details-modal(
  //-   :active.sync="showLearnMoreAboutAwardPoints"
  //-   has-modal-card
  //- )
  //-   .modal-card(style="width: auto")
  //-     section.modal-card-body.modal-card-body-no-head-no-foot
  //-       WtTitle(h3).pr-6 About Terryberry Award Points
  //-       WtIconButton.close-button(@click.native="showLearnMoreAboutAwardPoints = !showLearnMoreAboutAwardPoints" aria-label="Close modal")
  //-         BIcon(icon="close-circle" type="is-grey-light" size="is-medium")
  //-       .pt-2
  //-         .is-size-5.has-text-weight-bold Award Points:
  //-           span.pl-1.has-text-weight-light Redeem Award Points at Terryberry.
  //-         .is-size-5.has-text-weight-bold More info:
  //-           span.pl-1.has-text-weight-light The challenge creator incentized this challenge with Award Points that can be redeemed at Terryberry.

</template>

<script>
import { challengeMixin } from "@/mixins/challengeMixin";
import WtButton from "@@/WtButton/WtButton";
import WtIconButton from "@@/WtIconButton/WtIconButton";
import WtTitle from "@@/WtTitle/WtTitle";

export default {
  name: "ChallengeTerryberryAwardPoints",

  components: {
    WtButton,
    WtIconButton,
    WtTitle
  },

  mixins: [challengeMixin],

  props: {
    challenge: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      showLearnMoreAboutAwardPoints: false
    };
  },

  computed: {
    awardPointsAmount() {
      return this._.get(this.challenge, "incentivesAmount", "n/a");
    },

    dynamicAwardPointsText() {
      if (this._.get(this.challenge, "incentivesType", false) === "split") {
        return `Reach the challenge goal and split ${this.awardPointsAmount} Award points with all challenge winners!`;
      }
      if (this._.get(this.challenge, "incentivesType", false) === "award") {
        return `Reach the challenge goal and receive ${this.awardPointsAmount} Award points!`;
      }
      return "Reach the challenge goal and receive Award points.";
    }
  },

  methods: {
    clickLearnMore() {
      // this.showLearnMoreAboutAwardPoints = !this.showLearnMoreAboutAwardPoints;

      this.$emit("showChallengeDetails", true);
      this.$emit("awardPointsDescription", this.dynamicAwardPointsText);
    }
  }
};
</script>

<style lang="sass" scoped>
#ChallengeTerryberryAwardPoints
  border: 1px $white-bis solid
  .details-modal
    .close-button
      position: absolute
      top: .5rem
      right: .5rem
    .modal-card-body.modal-card-body-no-head-no-foot
      border-radius: $radius-large
    .modal-card-head, .modal-card-foot
      padding: .5rem
</style>
